export const transformations = {
  none: "t_none",
  small: "t_thumb_small",
  medium: "t_thumb_medium",
  large: "t_thumb_large",
  fullView: "t_full_view",
  fullRes: "t_fullres_large",
  lightbox2x: "t_lightbox_2x",
};

export const mediaTypes = {
  images: "baseImageUrl",
  videos: "baseVideoUrl",
};

export const getCloudinaryMediaUrl = (urls, type) =>
  urls ? urls.find((el) => el.name === type)?.url : "";

export const getImageUrl = (imageId, url, transformation) =>
  url && imageId ? `${url}${transformation}/q_auto,f_auto/${imageId}` : "";

export const getVideoUrl = (videoId, url, transformation) =>
  url && videoId ? `${url}${transformation}/${videoId}` : "";
